import { render, staticRenderFns } from "./PrkMainSyllabusHeader.vue?vue&type=template&id=19258010&scoped=true&"
import script from "./PrkMainSyllabusHeader.vue?vue&type=script&lang=js&"
export * from "./PrkMainSyllabusHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrkMainSyllabusHeader.vue?vue&type=style&index=0&id=19258010&scoped=true&lang=scss&"
import style1 from "./PrkMainSyllabusHeader.vue?vue&type=style&index=1&id=19258010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19258010",
  null
  
)

export default component.exports